<div class="carousel">
  <carousel-slider>
    @for (tradable of mostPopularList; track tradable) {
      <tradable-chart
        class="card-interactive most-popular"
        (onClick)="onClick(tradable)"
        [data]="{ tradable: tradable, timespan: timespan }">
      </tradable-chart>
    }
  </carousel-slider>
</div>
